/*
 * @Author: lzd 
 * @Date: 2020-11-04 10:48:59 
 * @Last Modified by: lzd
 * @Last Modified time: 2020-12-11 13:55:54
 */

let isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1;
let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

//这是必须要写的，用来创建一些设置
function setupWebViewJavascriptBridge(callback) {
    //Android使用
    if (isAndroid) {
        if (window.WebViewJavascriptBridge) {
            callback(window.WebViewJavascriptBridge);
        } else {
            document.addEventListener(
                'WebViewJavascriptBridgeReady',
                () => {
                    callback(window.WebViewJavascriptBridge);
                },
                false
            );
        }
        console.log('tag', '安卓');
        sessionStorage.phoneType = 'android';
    }

    //iOS使用
    if (isiOS) {
        if (window.WebViewJavascriptBridge) {
            return callback(window.WebViewJavascriptBridge);
        }
        if (window.WVJBCallbacks) {
            return window.WVJBCallbacks.push(callback);
        }
        window.WVJBCallbacks = [callback];
        var WVJBIframe = document.createElement('iframe');
        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(() => {
            document.documentElement.removeChild(WVJBIframe);
        }, 0);
        console.log('tag', 'ios');
        sessionStorage.phoneType = 'ios';
    }
}
//注册回调函数，第一次连接时调用 初始化函数(android需要初始化,ios不用)
setupWebViewJavascriptBridge((bridge) => {
    if (isAndroid) {
        //初始化
        bridge.init((message, responseCallback) => {
            var data = {
                'Javascript Responds': 'Wee!'
            };
            responseCallback(data);
        });
    }
});

export default {
    // js调APP方法 （参数分别为:app提供的方法名  传给app的数据  回调）
    callHandler(name, data, callback) {
        setupWebViewJavascriptBridge((bridge) => {
            bridge.callHandler(name, data, callback);
        });
    },
    // APP调js方法 （参数分别为:js提供的方法名  回调）
    registerHandler(name, callback) {
        console.log('name',name)
        setupWebViewJavascriptBridge((bridge) => {
            console.log('bridge',bridge)
            bridge.registerHandler(name, (data, responseCallback) => {
                console.log('data',data)
                callback(data, responseCallback);
            });
        });
    }
};




/**
 * app可调用的方法
 * 
 * 
 * getToken 获取app的信息（重要，参数详细可见permission.js调用）
 * 
 * goHome 关闭当前h5页面 回到首页
 * 
 * appCloseView 关闭当前h5页面
 * 
 * getMethodName 获取当前app有没有该方案  参数methodName  返回值 {result: success/fail,message:''}  
 * 
 * openContacts 打开通讯录  返回值 {name: '',phoneNumber:''}
 * 
 * openNewPage 打开新的页面 参数{url:''}
 * 
 * getLocationPermission 获取app地理位置权限
 * 
 * showToast 弹出提示消息  callHandler("showToast",'消息'） 
 * 
 * callPhone 拨打电话  callHandler("callPhone",'电话')
 * 
 * startToFace 打开人脸识别页面  参数{isCloseCurrentPage:'打开人脸识别后是否关闭当前页面'}
 */


// WEBPACK FOOTER //
// ./src/utils/JSbridge.js